module.exports = __webpack_public_path__ + "assets/img/introduction_culture_img_2.21a02658.png";